import MySnackbar from "./VSnackbar.vue"
import IconBtn from "./IconBtn.vue"
import IconSvg from "./IconSvg/IconSvg.vue"
import {
    VBluredImg,
    VImg,
} from "./Img"
import VSkeleton from "./VSkeleton.vue"
import VSwitch from "./VSwitch.vue"
import VCardList from "./VCardList.vue"
import VCard from "./VCard.vue"
import VSection from "./VSection.vue"
import { VTag, VTags } from "./Tag"
import { VInput } from "./Input"
import { VModal } from "./Modal";
import { VButton } from "./Button";
import { VGradualText, VNestedElements } from "./GradualText";

export default [
    MySnackbar,
    IconBtn,
    IconSvg,
    VBluredImg,
    VImg,
    VSkeleton,
    VSwitch,
    VCardList,
    VCard,
    VSection,
    VInput,
	VModal,
	VButton,
	VTag,
	VTags,

    VGradualText,
    VNestedElements,
]
